<template>
    <div class="legal-mentions bg-gray-100 p-8">
      <h1 class="text-3xl font-bold mb-6">Mentions Légales</h1>
      <p class="mb-8">
        Bienvenue sur [VotreSiteWeb.com]. Cette page contient les mentions légales
        régissant l'utilisation de notre site web.
      </p>
      <section class="mb-6">
        <h2 class="text-2xl font-semibold mb-4">1. Éditeur du site</h2>
        <p class="text-gray-700 space-y-2">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br>
          123 Rue Lorem, Appartement 456<br>
          Paris, 75001<br>
          exemple@email.com<br>
          +33 1 23 45 67 89
        </p>
      </section>
      <section class="mb-6">
        <h2 class="text-2xl font-semibold mb-4">2. Hébergement</h2>
        <p class="text-gray-700 space-y-2">
          Site hébergé par IpsumHost<br>
          789 Avenue Lorem, Bâtiment 012<br>
          Lyon, 69002
        </p>
      </section>
      <section class="mb-6">
        <h2 class="text-2xl font-semibold mb-4">3. Propriété intellectuelle</h2>
        <p class="text-gray-700">
          Le contenu de ce site est protégé par le droit d'auteur et est la propriété
          de [Votre nom ou nom de votre société]. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum.
        </p>
      </section>
      <!-- Ajoutez d'autres sections selon vos besoins -->
    </div>
  </template>
  
  <style scoped>
  /* Si vous souhaitez ajouter des styles supplémentaires spécifiques en dehors de Tailwind */
  </style>
  